import { createSuspenseBoundary } from './boundary.js';
import { createCacheProvider } from './cache.js';
import { createConfigProvider } from './config.js';
export const create = ({ cacheContextDisplayName, configContextDisplayName } = {}) => {
    const { BoundaryConfigProvider, useBoundaryConfig, } = createConfigProvider({ contextDisplayName: configContextDisplayName });
    const { CacheProvider, useConstantResource, useExpireCache, usePreloadConstantResource, usePreloadResource, usePreloadResourceCallback, useRefreshCache, useResource, useResourceController, useConstantResourceController, } = createCacheProvider({ contextDisplayName: cacheContextDisplayName });
    const { Boundary, withBoundary } = createSuspenseBoundary({ useBoundaryConfig, useExpireCache });
    return {
        BoundaryConfigProvider,
        CacheProvider,
        Boundary,
        useBoundaryConfig,
        useConstantResource,
        usePreloadConstantResource,
        usePreloadResource,
        usePreloadResourceCallback,
        useRefreshCache,
        useResource,
        useResourceController,
        useConstantResourceController,
        withBoundary,
    };
};
const { BoundaryConfigProvider, CacheProvider, Boundary, useBoundaryConfig, useConstantResource, usePreloadConstantResource, usePreloadResource, usePreloadResourceCallback, useRefreshCache, useResource, useResourceController, useConstantResourceController, withBoundary, } = create();
export { BoundaryConfigProvider, CacheProvider, Boundary, useBoundaryConfig, useConstantResource, usePreloadConstantResource, usePreloadResource, usePreloadResourceCallback, useRefreshCache, useResourceController, useConstantResourceController, useResource, withBoundary, };
export { default as ErrorBoundary } from './ErrorBoundary.js';
//# sourceMappingURL=index.js.map